import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  itemsPerPage, 
  totalItems 
}) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mt: 2,
        p: 2,
        borderTop: '1px solid #e0e0e0'
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Affichage de {startItem} à {endItem} sur {totalItems} éléments
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<ChevronLeft />}
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Précédent
        </Button>
        
        <Typography variant="body2" sx={{ mx: 2 }}>
          Page {currentPage} sur {totalPages}
        </Typography>
        
        <Button
          variant="outlined"
          size="small"
          endIcon={<ChevronRight />}
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Suivant
        </Button>
      </Box>
    </Box>
  );
};

export default Pagination;
